import { FastFilter } from '@vlabs/uikit';

import { withPopover } from '@vlabs/monokit/shared/ui/popovers/withPopover';

// eslint-disable-next-line import-x/no-namespace
import * as Popovers from './popovers';

const withBottomPopover = withPopover({ placement: 'bottom-start' });
const withFastBottomPopover = withBottomPopover(FastFilter);

export const LastLoginDateFilterWithBottomPopover = withFastBottomPopover(Popovers.LastLoginDateFilterPopover);
export const UserRoleFilterWithBottomPopover = withFastBottomPopover(Popovers.UserRoleFilterPopover);
export const DepartmentFilterWithBottomPopover = withFastBottomPopover(Popovers.DepartmentFilterPopover);
export const UserNameFilterWithBottomPopover = withFastBottomPopover(Popovers.UserNameFilterPopover);
export const UserEmailFilterWithBottomPopover = withFastBottomPopover(Popovers.UserEmailFilterPopover);
export const UserIdFilterWithBottomPopover = withFastBottomPopover(Popovers.UserIdFilterPopover);
export const DateCreatedFilterWithBottomPopover = withFastBottomPopover(Popovers.DateCreatedFilterPopover);
